<template>
  <div class="payment-search-checkboxes">
    <div class="loading-box" v-if="showLoading">
      <loading></loading>
    </div>
    <p class="payment-search-title">絞り込み</p>
    <div class="payment-status-box">
      <p class="checkbox-title payment-status-title">ステータス</p>
      <div class="checkbox-list payment-status-list">
        <ul>
          <li v-for="(status, index) in paymentStatusCheckboxList" :key="index">
            <label>
              <input type="checkbox" class="payment-status-checkbox" :ref="'payment-status-checkbox-' + index" v-model="selectedPaymentStatus" :value="status" /><span class="payment-status" :ref="'payment-status-' + index">{{ status.label }}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="payment-method-box">
      <p class="checkbox-title payment-method-title">支払い方法</p>
      <div class="checkbox-list payment-method-list">
        <ul>
          <li v-for="(method, index) in paymentMethodCheckboxList" :key="index">
            <label>
              <input type="checkbox" class="payment-status-checkbox" :ref="'payment-method-checkbox-' + index" v-model="selectedPaymentMethods" :value="method" /><span class="payment-method" :ref="'payment-method-' + index">{{ method.label }}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import consts from '../utils/consts';

export default {
  props: {
    get_audiences_path: { type: String, required: true },
  },
  data() {
    return {
      paymentStatusCheckboxList: [
        { id: 'paid', value: consts.PAY_STATUS.PAID, label: '支払済' },
        { id: 'before_paid', value: consts.PAY_STATUS.BEFORE_PAID, label: '支払待ち' },
        { id: 'refund', value: consts.PAY_STATUS.REFUND, label: '払い戻し' },
      ],
      paymentMethodCheckboxList: [
        { id: 'credit_card', value: consts.PAY_METHOD.CREDIT_CARD, label: 'クレカ' },
        { id: 'cvs', value: consts.PAY_METHOD.CVS, label: 'コンビニ' },
      ],
      selectedPaymentStatus: [{ id: 'paid', value: consts.PAY_STATUS.PAID, label: '支払済' }],
      selectedPaymentMethods: [],
      showLoading: false,
    };
  },
  created() {
    this.$store.commit('audience/setPaymentStatus', this.selectedPaymentStatus);
  },
  computed: {
    payment_status: function () {
      return this.$store.getters['audience/getPaymentStatus'];
    },
    payment_methods: function () {
      return this.$store.getters['audience/getPaymentMethods'];
    },
    currentPage: function () {
      return this.$store.getters['audience/getCurrentPage'];
    },
  },
  methods: {
    async upDateAudiences() {
      this.showLoading = true;
      // 1ページ目の場合はaudiencesを取得
      // それ以外の場合はcurrentPageを書き換える(書き換え先でaudiencesを取得)
      if (this.currentPage == 1) {
        const isAdmissionPage = false;
        await this.$store.dispatch('audience/getAudiences', { api_path: this.get_audiences_path, t: '', isAdmissionPage }).catch((error) => {
          alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        });
      } else {
        this.$store.commit('audience/setCurrentPage', 1);
      }
      this.showLoading = false;
    },
  },
  watch: {
    selectedPaymentStatus: function (newVal) {
      this.$store.commit('audience/setPaymentStatus', newVal);
      this.upDateAudiences();
    },
    payment_status: function (newVal) {
      this.selectedPaymentStatus = newVal;
    },
    selectedPaymentMethods: function (newVal) {
      this.$store.commit('audience/setPaymentMethods', newVal);
      this.upDateAudiences();
    },
    payment_methods: function (newVal) {
      this.selectedPaymentMethods = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;
.payment-search-checkboxes {
  width: 190px;
  margin-top: 60px;
  line-height: 1em;

  @media screen and (max-width: 1000px) {
    width: 120px;
  }

  @media screen and (max-width: $break-point) {
    display: none;
  }

  .payment-method-box {
    margin-top: 31px;
  }
  .payment-search-title {
    color: $shop-navy;
    font-weight: 600;
    font-size: 13px;
  }

  .checkbox-title {
    margin-top: 15px;
    color: $shop-navy;
    font-size: 13px;
    font-weight: 200;
  }

  .checkbox-list {
    margin-top: 10px;

    li {
      width: 90px;
    }
  }

  .checkbox-list label {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-weight: 300;
    font-size: 15px;
    cursor: pointer;
  }

  .payment-status-checkbox {
    width: 20px;
    height: 20px;
    background: $shop-disable-gray;
    border: 1px solid $shop-border-gray;
    border-radius: 4px;
    opacity: 1;
    position: relative;
    outline: none;
    margin-right: 10px;
    cursor: pointer;

    &:checked::before {
      content: '';
      position: absolute;
      top: 1px;
      left: 2px;
      width: 11px;
      height: 7px;
      border-left: solid 2px #fff;
      border-bottom: solid 2px #fff;
      transform: rotate(-39deg);
      background-color: transparent;
    }

    &::after {
      display: none;
    }

    .payment-status {
      width: 45px;
      height: 15px;
      text-align: left;
      color: #000;
    }
  }

  .payment-status-checkbox:checked {
    background: $shop-blue;
  }

  .loading-box {
    background-color: #000;
    opacity: 0.8;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .pg-performer-events--loader {
      position: fixed;
      top: 25%;
      left: 50%;
      z-index: 9999;
    }
  }
}
</style>
